import React from 'react';
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import './ContactUs.css';

const ContactUs = () => {
  return (
      <>
       <Header />
      <Navbar />
    <div className="contact-us-container">
      <section className="contact-header">
        <h2>Contact Us</h2>
        <p>
          Questions? Comments? Let your customers get in touch by filling out the form below.
          Our team will respond within 24 hours.
        </p>
      </section>

      <div className="contact-content">
        {/* Contact Form */}
        <div className="contact-form-section">
          <h3>Send us an email</h3>
          <form className="contact-form">
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email *" required />
            <input type="tel" placeholder="Phone number" />
            <textarea placeholder="Message" rows="5"></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>

        {/* Contact Info + Map */}
        <div className="contact-info-section">
          <h3>Contact Information</h3>
          <p><strong>Address:</strong> Plot No. 87/A, 2nd Floor, SHILPA HILLS, Opp. HITEX Exhibition Center, Shilpa Layout, Izzathnagar, Kothaguda, Hyderabad, Telangana 500084</p>
          <p><strong>Phone:</strong> <a href="tel:+919966477192">+91 - 99664 77192</a></p>
          <p><strong>Email:</strong> <a href="mailto:shravanth@spinelle.in">shravanth@spinelle.in</a></p>
          <p><strong>Opening Hours:</strong><br />
            Mon - Sun, 8:30am - 10:30pm
          </p>

    <div className="map-container">
  <iframe
    title="Spinelle Fine Jewelry Location"
    src="https://www.google.com/maps/embed/v1/place?q=Spinelle%20fine%20jewelry%202nd%20floor%2C%20main%20gate%2C%20SHILPA%20HILLS%2C%20plot%20no%2087%2FA%2C%20opp.%20to%20HITEX%20EXHIBITION%20CENTER%2C%20Shilpa%20Layout%2C%20Izzathnagar%2C%20Kothaguda%2C%20Hyderabad%2C%20Telangana%20500084&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    style={{ border: 0 }}
  ></iframe>
</div>

        </div>
      </div>
    </div>
       <Footer/>
         <HelpTrigger/>
    </>
  );
};

export default ContactUs;
